import { render } from "./PanelInformativo1.vue?vue&type=template&id=5cfbeaf0&scoped=true"
import script from "./PanelInformativo1.vue?vue&type=script&lang=js"
export * from "./PanelInformativo1.vue?vue&type=script&lang=js"

import "./PanelInformativo1.vue?vue&type=style&index=0&id=5cfbeaf0&scoped=true&lang=css"
import "./PanelInformativo1.vue?vue&type=style&index=1&id=5cfbeaf0&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfbeaf0"]])

export default __exports__